module.exports = __webpack_public_path__ + "img/newSearch.9d04da0e.svg";